import { render, staticRenderFns } from "./ReturnSchool2.vue?vue&type=template&id=8d6a2c7e&scoped=true&"
import script from "./ReturnSchool2.vue?vue&type=script&lang=js&"
export * from "./ReturnSchool2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6a2c7e",
  null
  
)

export default component.exports